import { KNOWLEDGE_ARTICLES, KNOWLEDGE_DOMAINS } from "./articles.js";
/** Find canonical domain metadata for a route segment, or return undefined. */
export function getKnowledgeDomain(domainId) {
    return KNOWLEDGE_DOMAINS.find((domain) => domain.id === domainId);
}
/** List guides in a domain in editorial order within the supplied catalogue. */
export function getDomainArticles(domainId, articles = KNOWLEDGE_ARTICLES) {
    return articles
        .filter((article) => article.domainId === domainId)
        .sort((left, right) => left.order - right.order);
}
/** Resolve a domain and slug only within the supplied catalogue. */
export function getKnowledgeArticle(domainId, slug, articles = KNOWLEDGE_ARTICLES) {
    return articles.find((article) => article.domainId === domainId && article.slug === slug);
}
//# sourceMappingURL=lookup.js.map